function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React from "react";
export var NvisoLogo = function(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        width: "142",
        height: "38",
        viewBox: "0 0 142 38",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M108.055 24.7034L109.951 27.1194L105.112 29.9272L107.041 34.2368L111.553 35.6082L113.81 30.3843L116.491 31.8535L125.189 32.9309L140.426 30.9067L128.36 23.2014L119.695 22.1567L121.069 17.9124L117.112 19.9692L114.66 11.6111L105.079 1L105.57 16.3452L108.055 24.7034Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M73.1981 29.666C73.2172 25.1519 69.3522 23.9934 66.1285 23.0273C63.8267 22.3374 61.8518 21.7456 61.8518 20.0999C61.8518 18.5654 63.1924 17.9778 64.9908 17.9778C66.8873 17.9778 69.2416 18.696 71.1381 19.8713L72.8384 16.4431C70.9092 15.072 68.0645 14.2883 65.3505 14.2883C61.2632 14.2883 57.4702 16.1494 57.4702 20.459C57.4515 24.8545 61.1036 25.9458 64.2448 26.8843C66.6101 27.5911 68.6857 28.2112 68.6857 30.0906C68.6857 31.6904 67.1489 32.376 65.187 32.376C62.8654 32.376 59.8898 31.364 58.026 29.7314L56.3911 33.0291C58.5165 34.9553 61.8518 36.0002 64.9908 36.0002H65.0236C69.307 36.0002 73.1981 34.041 73.1981 29.666Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M31.0828 35.8694L22.8101 14.4841H27.6494L33.6005 31.2986L35.1139 26.9751L39.4536 14.4841H44.0968L35.8894 35.8694H31.0828Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M52.1079 35.8694H47.53L47.5298 35.8367L47.53 14.4841H52.1079V35.8694Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M87.3894 14.3208C93.9945 14.3208 98.5397 18.6958 98.5397 25.1604C98.5397 31.5923 94.0272 36 87.3894 36C80.7516 36 76.2065 31.625 76.2065 25.1604C76.2065 18.6958 80.7843 14.3208 87.3894 14.3208ZM80.8824 25.1931C80.8824 29.3396 83.5637 32.1472 87.4221 32.1472C91.2478 32.1472 93.9292 29.3069 93.9292 25.1931C93.9292 21.0791 91.2805 18.2715 87.4221 18.2715C83.5637 18.2715 80.8824 21.1118 80.8824 25.1931Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.64319 20.9814L4.95654 18.4675L7.57239 19.1531H11.7251C15.7469 19.1531 16.8915 20.6223 16.8915 24.377V35.9021H21.5345V22.6138C21.5345 17.5205 18.5591 14.5496 13.5562 14.5496H1V35.9021H5.64319V20.9814Z"
    }));
};

//# sourceMappingURL=NvisoLogo.js.map